import { ContextualItemTypeVariant, useAPI } from '@nexelem/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../hooks';
import { productItemVariantsQueryKey } from './useProductItemVariants';

export const useSaveVariant = (itemTypeId: number) => {
  const api = useAPI();
  const queryClient = useQueryClient();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.detailsPage.variants');

  return useMutation({
    mutationFn: (data: ContextualItemTypeVariant) => api.postBackItemsVariants({ contextualItemTypeVariant: data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productItemVariantsQueryKey(itemTypeId) });
      displayToast({
        toastType: 'success',
        message: tWrapper('toast.saveSuccess'),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('toast.saveError'),
      });
    },
  });
};
